import { Box, Divider, Grid, Paper } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { getInvoiceGroupById } from 'src/shared/services/invoiceGroupService';
import AdminInvoiceGroupTabNavigation from '../components/adminInvoiceGroupTabNavigation';
import { AdminInvoiceGroupPaymentMethodsTab } from '../components/adminInvoiceGroupPaymentMethodsTab';
import { AdminInvoiceGroupAccountingTab } from '../components/adminInvoiceGroupAccountingTab';

export const AdminInvoiceGroupDetailPage = () => {
  const { id } = useParams();
  const { pathname } = useLocation();
  const isAccounting = pathname.endsWith('/accounting');
  const isMounted = useIsMounted();
  const [invoiceGroupName, setInvoiceGroupName] = useState('');

  useEffect(() => {
    if (!id) return;

    const fetchInvoiceGroupName = async () => {
      try {
        const result = await getInvoiceGroupById(+id);
        if (!isMounted()) return;
        setInvoiceGroupName(result.data.name ?? '');
      } catch (err) {
        if (isMounted()) ConsoleHelper.log(err);
      }
    };

    fetchInvoiceGroupName();
  }, [id, isMounted]);

  return (
    <GridWrapper>
      <Grid item xs='auto' sx={{ display: 'flex', alignItems: 'center' }}>
        <MainContentHeader title={invoiceGroupName} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <AdminInvoiceGroupTabNavigation />
          <Divider />
          <Box sx={{ p: 3 }}>{isAccounting ? <AdminInvoiceGroupAccountingTab /> : <AdminInvoiceGroupPaymentMethodsTab />}</Box>
        </Paper>
      </Grid>
    </GridWrapper>
  );
};
